import { PrivacyPolicy, theme } from 'ComponentLibrary'
import { ThemeProvider } from '@mui/material'
import { useEffect } from 'react'
import type { FooterLocale } from 'ComponentLibrary/src/molecules/Footer/footerCopy'

type PrivacyPolicyPageProps = {
    locale: FooterLocale
}

export const PrivacyPolicyPage = ({ locale }: PrivacyPolicyPageProps) => {
    useEffect(() => {
        document.documentElement.lang = locale
    }, [locale])

    return (
        <ThemeProvider theme={theme}>
            <PrivacyPolicy isPrivacyPolicyOpen={true} locale={locale} />
        </ThemeProvider>
    )
}
